import type { ChannelFilter } from "../types/contract";
import { CHANNEL_META, CHANNEL_TABS } from "../lib/meta";

interface ChannelTabsProps {
  value: ChannelFilter;
  onChange: (c: ChannelFilter) => void;
}

export function ChannelTabs({ value, onChange }: ChannelTabsProps) {
  return (
    <div className="tab-row" role="tablist">
      {CHANNEL_TABS.map((id) => (
        <button
          key={id}
          role="tab"
          aria-selected={value === id}
          className={`tab-btn ${value === id ? "active" : ""}`}
          onClick={() => onChange(id)}
        >
          {CHANNEL_META[id].label}
        </button>
      ))}
    </div>
  );
}
